import { Table } from "@/features/Table";
import { type View, views_columns } from "./columns";
import { type FilterViewSchema, FilterView } from "./filter";
import { useLocation } from "react-router-dom";

const client = "tableau-quantilia";
const table_name = "views";

export const ViewsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<View, FilterViewSchema>
      label="Views"
      client={client}
      table_name={table_name}
      columns={views_columns}
      filter={<FilterView />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
